import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

interface ByzMuiDocummentsButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
}

const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup }) => ({
  borderRadius: popup ? "20px" : "4px",
  padding: "4px 20px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  border: "1px solid #2979C3",
  backgroundColor: "#63B4FF33",
  color: "#2979C3",
  "&:hover": {
    backgroundColor: "#2979C3",
    color: "#fff",
  },
}));

const ByzMuiAddButton: React.FC<ByzMuiDocummentsButtonProps> = ({ onClick, link, popup }) => {
  const { t } = useTranslate();

  const buttonContent = (
    <ByzMuiTypography
      fontWeight={400}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {t("buttons.documents")}
    </ByzMuiTypography>
  );

  if (link) {
    return (
      <Link to={link} style={{ textDecoration: "none" }} role="button" tabIndex={0}>
        <StyledButton popup={popup}>{buttonContent}</StyledButton>
      </Link>
    );
  }

  return (
    <StyledButton onClick={onClick} popup={popup}>
      {buttonContent}
    </StyledButton>
  );
};

export default ByzMuiAddButton;
